import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Eye as EyeIcon, PlusCircle as PlusCircleIcon } from 'react-feather'
import { Box, Button, Tooltip } from '@material-ui/core'

import usePermissions from 'hooks/usePermissions'

import constants from 'constants/index'

const DocumentTemplateAction = ({
  companyPrivacyPolicies = [],
  companyDocumentTemplateId,
  disabledInputs = false,
  onOpenDialog = () => {},
  onCreateDocument = () => {},
}) => {
  const { PRIVACY_POLICIES } = constants.permissions

  const { permitted } = usePermissions()

  const canCreateDocument = permitted(PRIVACY_POLICIES.CREATE)

  // Com documento na organização a decisão é do modal — é lá que o usuário compara os documentos,
  // vê o conteúdo e escolhe entre vincular um deles ou gerar outro. Sem documento algum não há o que
  // comparar, então a linha leva direto para a criação.
  if (!isEmpty(companyPrivacyPolicies)) {
    return (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        startIcon={<EyeIcon size={16} />}
        onClick={onOpenDialog}
      >
        Ver documentos
      </Button>
    )
  }

  const mountBlockedTooltip = () => {
    if (disabledInputs)
      return 'Esta evidência não pode ser alterada no momento.'

    if (!companyDocumentTemplateId) {
      return 'Este modelo de documento não está disponível para a sua organização.'
    }

    if (!canCreateDocument) {
      return 'Você não possui permissão para criar documentos.'
    }

    return ''
  }

  const blockedTooltip = mountBlockedTooltip()

  if (blockedTooltip) {
    return (
      <Tooltip title={blockedTooltip}>
        <Box>
          <Button color="primary" variant="outlined" size="small" disabled>
            Criar documento
          </Button>
        </Box>
      </Tooltip>
    )
  }

  return (
    <Button
      color="primary"
      variant="outlined"
      size="small"
      startIcon={<PlusCircleIcon size={16} />}
      onClick={onCreateDocument}
    >
      Criar documento
    </Button>
  )
}

DocumentTemplateAction.propTypes = {
  companyPrivacyPolicies: PropTypes.array,
  companyDocumentTemplateId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  disabledInputs: PropTypes.bool,
  onOpenDialog: PropTypes.func,
  onCreateDocument: PropTypes.func,
}

export default DocumentTemplateAction
